import React from "react";
import "./Order_details_table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Form, Table } from "react-bootstrap";

function Order_details_table({
  selectedItems,
  setSelectedItems,
  setError,
  order,
}) {
  const handleCheckboxChange = (val) => {
    setError("");
    setSelectedItems((prev) => {
      const exists = prev.some((item) => item.id === val.id); // use a unique ID or index
      if (exists) {
        return prev.filter((item) => item.id !== val.id);
      } else {
        return [...prev, val]; // or just store val.id if needed
      }
    });
  };
  return (
    <>
      {order?.Product_Order_Details?.map((product) => (
        <div className="product_content_holder cancel_order_details_table">
          <div className="product_content">
            <div className="product_detail_inner">
              <div className="left_side">
                <Form.Check
                  type={"checkbox"}
                  className="cancel_check"
                  checked={selectedItems?.some(
                    (item) => item.id === product.id
                  )}
                  onChange={() => handleCheckboxChange(product)}
                />
                <div className="img_holder">
                  <img
                    src={
                      process.env.REACT_APP_IMG_URL + product?.Product?.image
                    }
                  />
                </div>

                <div className="text_holder">
                  <div className="product_name">
                    <p>{product?.Product_Variant?.name}</p>
                  </div>
                  <div className="weight">
                    <p>{order?.total_kg} kg</p>
                  </div>
                </div>
              </div>

              <div>
                <div className="qty_holder">
                  <p>
                    x {product?.quantity}{" "}
                    <span className="price">
                      {product?.total_selling_price}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div className="addon_catagory_list_holder">
              <ul>
                <li>
                  <b>Add On :</b>
                  {product?.Product_Order_Detail_Addons?.map((val) => (
                    <div className="addon_text_holder">
                      <div className="product_name">
                        <h5> {val?.Addon?.name}</h5>
                      </div>
                    </div>
                  ))}
                </li>
              </ul>

              {/* {props?.cartVarient?.Cart_Addon_Multiples?.map((val)=>
                    <>
                    {val?.Addon_Category?.name}:{val?.Addon?.name}
                    </>
                    )} 
                   
                    {props?.cartVarient?.Cart_Addon_Singles?.map((val)=>
                    <>
                     {val?.Addon_Category?.name}:{val?.Addon?.name}
                    </>
                    )} */}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default Order_details_table;
